module.exports = require('./helpers/bundle-url').getBundleURL('5GvXU') + "logo.c51670a8.svg";